import Proxy from './Proxy';

class SocialServiceProxy extends Proxy {
    constructor(parameters = {}) {
        super('/social-service', parameters);
    }
}

export default SocialServiceProxy;
